module.exports = __webpack_public_path__ + "static/media/bg-form.09171203.png";